import { wishListCardStyles } from "@insite/content-library/Components/WishListCard";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { COLORS, TYPOGRAPHY } from "@store/theme/common/design";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

Object.assign(wishListCardStyles, {
    detailLinkGridItem: {
        width: 12,
        align: "middle",
        css: css`
            ${TypographyStyle} {
                color: ${COLORS.secondary.base};
                font-size: ${TYPOGRAPHY.size.small};
                font-weight: ${TYPOGRAPHY.weight.bold};
            }
        `,
    },
    productImagesGridItem: {
        width: [12, 12, 12, 6, 6],
        align: "middle",
        css: css`
            flex-wrap: wrap;
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, null, "center", null, null], properties: ["justify-content"] }],
                    mediaOptions.min,
                )}
        `,
    },
    sharingStatusGridItem: {
        width: [12, 12, 12, 6, 6],
        align: "middle",
        css: css`
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: [null, null, "center", null, null], properties: ["justify-content"] }],
                    mediaOptions.min,
                )}
        `,
    },
    sharingStatus: {
        statusText: {
            css: css`
                display: flex;
                ${({ theme }) =>
                    breakpointValuesMediaQueries(
                        theme,
                        [{ values: ["10px", null, "0", null, null], properties: ["margin-left"] }],
                        mediaOptions.min,
                    )}
            `,
        },
        privateTooltip: {
            cssOverrides: {
                tooltipWrapper: css`
                    ${({ theme }) =>
                        breakpointValuesMediaQueries(
                            theme,
                            [{ values: ["20px", null, "10px", null, null], properties: ["margin-left"] }],
                            mediaOptions.min,
                        )}
                `,
            },
        },
    },
    basicInfoGridItem: {
        width: [12, 12, 5, 5, 5],
        align: "middle",
    },
    extendedInfoGridItem: {
        width: [12, 12, 7, 7, 7],
        align: "middle",
    },
    actionAddToCartButton: {
        color: "primary",
        css: css`
            white-space: nowrap;
            width: 100%;
            padding: 0 10px;
        `,
    },
    actionGridItem: {
        width: [2, 2, 4, 2, 2],
        align: "top",
        css: css`
            justify-content: flex-end;
        `,
    },
    actionDeleteButton: {
        variant: "secondary",
        css: css`
            width: 100%;
            margin-top: 10px;
        `,
    },
});
